import React, { useEffect } from 'react';
import { Select } from 'antd';
import MetricsChart from './MetricsChart';
import { Metric } from '../../../interfaces/IMetricChart';


interface MetricDropDownProps {
    metrics: Metric[];
    updateFilter: (key: string, value: any) => void
    selectedMetricY1: string | undefined
    setSelectedMetricY1: React.Dispatch<React.SetStateAction<string | undefined>>
    selectedMetricY2: string | undefined
    setSelectedMetricY2: React.Dispatch<React.SetStateAction<string | undefined>>
    selectedTypeY1: string | undefined;
    setSelectedTypeY1: React.Dispatch<React.SetStateAction<string>>;
    selectedTypeY2: string | undefined;
    setSelectedTypeY2: React.Dispatch<React.SetStateAction<string>>;
    selectedStackingY1: string | undefined;
    setSelectedStackingY1: React.Dispatch<React.SetStateAction<string>>;
    selectedStackingY2: string | undefined;
    setSelectedStackingY2: React.Dispatch<React.SetStateAction<string>>;
    setRollingWindowSizeY1:React.Dispatch<React.SetStateAction<number>>;
    rollingWindowSizeY1:number;
    setRollingWindowSizeY2:React.Dispatch<React.SetStateAction<number>>;
    rollingWindowSizeY2:number;
    performanceMetricsData:Metric[];
}

const MetricChartDropdown: React.FC<MetricDropDownProps> = ({ metrics, updateFilter, setSelectedMetricY2, selectedMetricY2, selectedMetricY1, setSelectedMetricY1,selectedTypeY1, setSelectedTypeY1,selectedTypeY2, setSelectedTypeY2,selectedStackingY1, setSelectedStackingY1,selectedStackingY2, setSelectedStackingY2, setRollingWindowSizeY1, setRollingWindowSizeY2, rollingWindowSizeY1, rollingWindowSizeY2, performanceMetricsData }) => {

    useEffect(() => {
        if (!selectedMetricY1 && !selectedMetricY2 && metrics.length > 0) {
            setSelectedMetricY1(metrics[0]?.name);
            setSelectedMetricY2(metrics[1]?.name);
        }
    }, [metrics]);
    


    const filteredMetricY1 = metrics.find((metric) => metric.name === selectedMetricY1);
    const filteredMetricY2 = metrics.find((metric) => metric.name === selectedMetricY2);
    const rollingAverageMaxCountForY1=performanceMetricsData.find((metric)=>metric.name===selectedMetricY1)?.data.length || 0;
    const rollingAverageMaxCountForY2=performanceMetricsData.find((metric)=>metric.name===selectedMetricY2)?.data.length || 0;
    const getMaxMetricWidth = (metrics: { name: string; units?: string }[], selectedMetric: string) => {
        
        const selected = metrics.find((metric) => metric.name === selectedMetric);
    
        if (selected) {
            const metricText = `${selected.name} ${selected.units || ''}`;
            return Math.min(metricText.length * 12, 200);
        }
    
        return 180;
    };
    
    const metricDropdownWidthY1 = getMaxMetricWidth(metrics, selectedMetricY1 || ''); 
    const metricDropdownWidthY2 = getMaxMetricWidth(metrics, selectedMetricY2 || '');
    
    const filteredY2Options = metrics.filter(metric => metric.name !== selectedMetricY1);
    const filteredY1Options = metrics.filter(metric => metric.name !== selectedMetricY2);

    return (
        <>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: "12px" }}>
                <h3 className="card-title" style={{ margin: 0, paddingRight: "12px" }}>Trend Analysis</h3>

                <Select
                    value={selectedMetricY1}
                    style={{ width: metricDropdownWidthY1 }}
                    onChange={(value) => {
                        setSelectedMetricY1(value);
                        updateFilter('analysisA', value)
                    }}
                    className="transparent-border-dropdown"
                >
                    {filteredY1Options.map((metric) => (
                        <Select.Option key={metric.name} value={metric.name}>
                            {metric.name} {metric.units ? `(${metric.units})` : ''}
                        </Select.Option>
                    ))}
                </Select>

                <h3 style={{ margin: '0 12px' }}> vs </h3>

                <Select
                    value={selectedMetricY2}
                    style={{ width: metricDropdownWidthY2 }}
                    onChange={(value) => {
                        setSelectedMetricY2(value);
                        updateFilter('analysisB', value)
                    }}
                    className="transparent-border-dropdown2"
                >
                    <Select.Option key="empty" value="">
                       None
                    </Select.Option>
                    {filteredY2Options.map((metric) => (
                        <Select.Option key={metric.name} value={metric.name}>
                            {metric.name} {metric.units ? `(${metric.units})` : ''}
                        </Select.Option>
                    ))}
                </Select>
            </div>
            <div className="card-body">
            {(filteredMetricY1?.data.length ?? 0) > 0 || (filteredMetricY2?.data.length ?? 0) > 0 ? (
                <MetricsChart
                    selectedMetricY1={filteredMetricY1}
                    selectedMetricY2={filteredMetricY2}
                    selectedTypeY1={selectedTypeY1}
                    setSelectedTypeY1={setSelectedTypeY1}
                    selectedTypeY2={selectedTypeY2}
                    setSelectedTypeY2={setSelectedTypeY2}
                    selectedStackingY1={selectedStackingY1}
                    setSelectedStackingY1={setSelectedStackingY1}
                    selectedStackingY2={selectedStackingY2}
                    setSelectedStackingY2={setSelectedStackingY2}
                    updateFilter={updateFilter}
                    rollingWindowSizeY1={rollingWindowSizeY1}
                    setRollingWindowSizeY1={setRollingWindowSizeY1}
                    rollingWindowSizeY2={rollingWindowSizeY2}
                    setRollingWindowSizeY2={setRollingWindowSizeY2}
                    rollingAverageMaxCountForY1={rollingAverageMaxCountForY1}
                    rollingAverageMaxCountForY2={rollingAverageMaxCountForY2}
                />
        ) : (
            <div className="flex items-center justify-center h-64 text-gray-500 font-medium text-lg">
                No data available.
            </div>
        )}
            </div>

        </>
    );
};

export default MetricChartDropdown;
